import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="min-h-screen bg-white pt-[100px] md:pt-[110px] flex items-center justify-center px-4">
      <div className="text-center max-w-lg">
        <div className="w-20 h-20 mx-auto mb-6 rounded-full bg-hj-red/10 flex items-center justify-center">
          <i className="ri-error-warning-line text-3xl text-hj-red"></i>
        </div>
        <h1 className="text-4xl md:text-5xl font-bold text-hj-dark font-heading">404</h1>
        <h2 className="text-lg md:text-xl font-semibold text-hj-dark mt-2 font-heading">
          Seite nicht gefunden
        </h2>
        <p className="text-sm text-hj-gray mt-3 font-body">
          Die Seite <code className="bg-hj-gray-light px-1.5 py-0.5 rounded text-hj-dark font-mono text-xs">{location.pathname}</code> existiert nicht.
        </p>
        <div className="flex flex-wrap justify-center gap-3 mt-8">
          <Link
            to="/"
            className="px-5 py-2.5 bg-hj-red text-white text-sm font-medium rounded-md hover:bg-hj-red-light transition-colors whitespace-nowrap"
          >
            <i className="ri-home-line mr-1.5"></i>
            Zur Startseite
          </Link>
          <Link
            to="/suche"
            className="px-5 py-2.5 border border-hj-gray-border text-hj-dark text-sm font-medium rounded-md hover:bg-hj-gray-light transition-colors whitespace-nowrap"
          >
            <i className="ri-search-line mr-1.5"></i>
            Suchen
          </Link>
        </div>
        <div className="mt-8 pt-6 border-t border-hj-gray-border">
          <p className="text-xs text-hj-gray font-body mb-3">Beliebte Kategorien:</p>
          <div className="flex flex-wrap justify-center gap-2">
            {["Schweiz", "Finanzen", "Technologie", "Politik", "Gesundheit"].map((cat) => (
              <Link
                key={cat}
                to={`/${cat.toLowerCase()}`}
                className="px-3 py-1.5 text-xs text-hj-red border border-hj-red/30 rounded-full hover:bg-hj-red hover:text-white transition-colors font-body"
              >
                {cat}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}